import { ICON_HEIGHT_32, IconNG } from '../../Icon'
import { BirdviewCard } from '../BirdviewCard'
import { BirdviewGretaRow } from '../BirdviewGretaRow'

import { BirdviewGretaApproveAllButton } from './BirdviewGretaApproveAllButton'

import GretaAvatarIcon from '../../../icons/unique/ai/avatar.svg'

function BirdviewGretaWidget({ dragHandleProps, section, title }) {
  return (
    <BirdviewCard
      isAI
      Action={BirdviewGretaApproveAllButton}
      TitleBefore={IconNG}
      count={section.total}
      dragHandleProps={dragHandleProps}
      isRefreshing={section.isRefreshing}
      state={section.state}
      title={title}
      titleBeforeProps={{ Icon: GretaAvatarIcon, size: ICON_HEIGHT_32 }}
      onRetry={section.reload}
    >
      {section.items.map(item => (
        <BirdviewGretaRow item={item} key={item.id} />
      ))}
    </BirdviewCard>
  )
}

export default BirdviewGretaWidget
